import Swiper from "swiper";
import {Autoplay} from "swiper/modules";

export const gallery = () => {
  const sliders = document.querySelectorAll('.gallery-slider .swiper') as NodeListOf<HTMLDivElement>

  sliders?.forEach(slider => {
    new Swiper(slider, {
      modules: [Autoplay],
      loop: true,
      speed: 6500,
      slidesPerView: "auto",
      freeMode: true,
      autoplay: {
        delay : 0,
      },
    })
  })
}
